import React from 'react';

import LoginForm from 'containers/LoginForm';

const SignIn = () => {
  return <LoginForm />;
}

export default SignIn;